import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import ErrorResponse from './ErrorResponse';
import List from './List';
import mapList from './mapList';
import ProductUpdate from './ProductUpdate';

export interface Result {
	czReimbursement: List;
}

export default function updateList(
	client: ApiClient,
	userId: string,
	groupId: string,
	packageSize: number | null,
	dosageStrength: number | null,
	usualTherapeuticDailyDose: number | null,
	usualTherapeuticDailyDosePerPackage: number | null,
	products: ProductUpdate[]
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/cz-reimbursement-list');

	return client
		.fetch(url.expand({ userId, groupId }), {
			method: 'PUT',
			body: JSON.stringify({
				reference: {
					packageSize,
					dosageStrength,
					usualTherapeuticDailyDose,
					usualTherapeuticDailyDosePerPackage,
				},
				products: products.map((product) => ({
					id: product.id,
					priceTypeForCalculation: product.priceTypeForCalculation,
					packageSizeForSingleUnit: product.packageSizeForSingleUnit,
					selected: product.selected,
				})),
			}),
		})
		.then((response) => response.json())
		.then((response) => ({
			czReimbursement: mapList(response.czReimbursement),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, ErrorResponse));
}
